import React from 'react';

const NotificationBadge = ({ 
  count = 0, 
  max = 99,
  variant = 'error',
  size = 'default',
  showZero = false,
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4 text-[10px]',
    default: 'w-5 h-5 text-xs',
    lg: 'w-6 h-6 text-sm'
  };

  const variantClasses = {
    error: 'bg-error text-error-foreground',
    warning: 'bg-warning text-warning-foreground',
    success: 'bg-success text-success-foreground',
    primary: 'bg-primary text-primary-foreground',
    accent: 'bg-accent text-accent-foreground'
  };

  const displayCount = count > max ? `${max}+` : count;
  const shouldShow = showZero || count > 0;

  if (!shouldShow) return null;

  return (
    <span
      className={`
        inline-flex items-center justify-center
        ${sizeClasses?.[size]}
        ${variantClasses?.[variant]}
        rounded-full font-semibold
        ${className}
      `}
    >
      {displayCount}
    </span>
  );
};

export default NotificationBadge;